import { registerPlugin } from "@capacitor/core"
import type { InAppCameraPlugin } from "./definitions"

const InAppCamera = registerPlugin<InAppCameraPlugin>("InAppCameraPlugin", {
	web: () => import("./web").then((m) => new m.InAppCameraWeb()),
})

export { InAppCamera }
export * from "./definitions"
